import React, { Component } from "react";
import { Alert, Button, Layout, Tag } from "antd";

import Sidebar from "../Sidebar/index";
import HorizontalDefault from "../Topbar/HorizontalDefault/index";
import HorizontalDark from "../Topbar/HorizontalDark/index";
import InsideHeader from "../Topbar/InsideHeader/index";
import AboveHeader from "../Topbar/AboveHeader/index";
import BelowHeader from "../Topbar/BelowHeader/index";

import Topbar from "../Topbar/index";
import { footerText, footerLink } from "util/config";
import App from "routes/index";
import { connect } from "react-redux";
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE
} from "../../constants/ThemeSetting";
import NoHeaderNotification from "../Topbar/NoHeaderNotification/index";
import { version } from './../../../package.json';
import ErrorBoundary from "../../util/ErrorBoundary";
// import Customizer from '../Customizer';
import './style.css';

const { Content, Footer } = Layout;

export class MainApp extends Component {

  state = {
    uiEnvironment: 'development',
    isNewUiVersion: false,
    key: 'Reload'
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (nextProps && nextProps.app && JSON.stringify(nextProps.app) !== JSON.stringify(this.props.app)) {
      // console.log(nextProps.app)
      const { apiVersion } = nextProps.app || {};
      const existingSavedVersion = localStorage.getItem("ast-version");
      if (existingSavedVersion !== JSON.stringify(apiVersion)) {
        localStorage.setItem("ast-version", JSON.stringify(apiVersion));
        this.setState({ isNewUiVersion: true })
      }
      const userAgent = navigator.userAgent;
      if (userAgent.match(/Macintosh/i)) {
        this.setState({ key: 'Cmd+Shift+R' })
      } else if (userAgent.match(/Windows/i)) {
        this.setState({ key: 'Ctrl+F5' })
      }
    }
  }

  getContainerClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DARK_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-container-wrap";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-container-wrap";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-container-wrap";
      default:
        return ""
    }
  };
  getNavStyles = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return <HorizontalDefault />;
      case NAV_STYLE_DARK_HORIZONTAL:
        return <HorizontalDark />;
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return <InsideHeader />;
      case NAV_STYLE_ABOVE_HEADER:
        return <AboveHeader />;
      case NAV_STYLE_BELOW_HEADER:
        return <BelowHeader />;
      case NAV_STYLE_FIXED:
        return <Topbar />;
      case NAV_STYLE_DRAWER:
        return <Topbar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Topbar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <NoHeaderNotification />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <NoHeaderNotification />;
      default:
        return null;
    }
  };
  getSidebar = (navStyle, width) => {
    if (width < TAB_SIZE) {
      return <Sidebar />;
    }
    switch (navStyle) {
      case NAV_STYLE_FIXED:
        return <Sidebar />;
      case NAV_STYLE_DRAWER:
        return <Sidebar />;
      case NAV_STYLE_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_MINI_SIDEBAR:
        return <Sidebar />;
      case NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR:
        return <Sidebar />;
      default:
        return null;
    }
  };

  handleReload = async () => {
    try {
      // Clear cookies
      document.cookie.split(";").forEach((cookie) => {
        const name = cookie.split("=")[0].trim();
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
      });

      // Clear session storage
      sessionStorage.clear();

      // Clear all caches including service worker cache
      if ('caches' in window) {
        const cacheKeys = await caches.keys();
        await Promise.all(
          cacheKeys.map(cacheKey => caches.delete(cacheKey))
        );
      }

      // Unregister service worker to ensure clean state
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        await Promise.all(registrations.map(registration => registration.unregister()));
      }

      // Clear localStorage except version info
      const versionInfo = localStorage.getItem("ast-version");
      localStorage.clear();
      if (versionInfo) {
        localStorage.setItem("ast-version", versionInfo);
      }

      // Force reload with cache bypass
      window.location.reload(true);
    } catch (error) {
      console.error('Error during reload:', error);
      // Fallback reload if something fails
      window.location.reload(true);
    }
  }

  render() {
    const { match, width, navStyle, modules, error, authUser } = this.props;
    // console.log(error);
    // if(error){
    //   message.error(error);
    // }
    let title = (authUser && authUser.organisation && authUser.organisation.name) || 'AssetPro';
    return (
      <ErrorBoundary>
        <Alert style={{ display: this.state.isNewUiVersion ? 'block' : 'none' }} type="warning"
          description={<div style={{ display: 'flex', flexDirection: 'row' }}><h4>New updates are available, please click on reload to get the updates! or
            Press {this.state.key}</h4><Button style={{ marginLeft: '10px' }}
              size={'small'} type={'dashed'} onClick={this.handleReload}>RELOAD</Button></div>}
          closable showIcon />
        <Layout className="gx-app-layout">
          {this.getSidebar(navStyle, width)}
          {/*<Customizer/>*/}
          <Layout>
            {this.getNavStyles(navStyle)}
            <Content className={`gx-layout-content ${this.getContainerClass(navStyle)} `}>
              <App match={match} modules={modules} authUser={authUser} />
              <Footer className={'hidePrint'} style={{ padding: '0px 10px' }}>
                <div style={{ display: "flex", justifyContent: 'space-between', marginTop: '10px' }}
                  className="gx-layout-footer-content">
                  <span>{footerText}
                    <a
                    // href={footerLink.href}
                    // href="#"
                    // target={footerLink.target}
                    // rel={footerLink.rel}
                    >
                      {footerLink.text}
                    </a>
                  </span>
                  <span style={{ color: '#1890ff' }}>Subscriber license : {title}</span>
                  <span>v{version} <Tag>{process.env.REACT_APP_ENVIRONMENT || ''}</Tag></span>
                </div>
              </Footer>
            </Content>
          </Layout>
        </Layout>
      </ErrorBoundary>
    )
  }
}

const
  mapStateToProps = ({ settings, commonData, auth }) => {
    const { authUser } = auth;
    const { width, navStyle, app } = settings;
    const { modules, error } = commonData;
    return { width, navStyle, modules, error, authUser, app }
  };
export default connect(mapStateToProps)

  (
    MainApp
  )
  ;
